import { Observable, Subject } from 'rxjs';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { AdvancedSearchService } from 'src/search/services/advanced-search/advanced-search.service';
import { takeUntil } from 'rxjs/operators';
import { VehicleInfo } from '../../../../../../app/enums/vehicleInfo.enum';
import { AdvancedSearchOption, ModelOptionState } from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-advanced-search-model',
    templateUrl: './advanced-search-model.component.html',
    styleUrls: ['./advanced-search-model.component.scss'],
    imports: [TranslocoDirective, AccordionModule, CommonModule]
})
export class AdvancedSearchModelComponent implements OnInit, OnDestroy {
  @Output() closePop = new EventEmitter();

  modelOptions$: Observable<ModelOptionState> = this.advancedSearchService.modelOptions;

  filteredModelOPtions: Array<AdvancedSearchOption> = [];
  formattedModelOptions: { [make: string]: AdvancedSearchOption };

  selectedModelOptions: Array<AdvancedSearchOption> = [];
  selectedModelOptionsValue: Array<string> = [];

  searchModel: string;

  selectedModelCount: { [make: string]: number } = {};

  private destroyed$ = new Subject();

  constructor(private advancedSearchService: AdvancedSearchService) {}

  ngOnInit() {
    this.modelOptions$.pipe(takeUntil(this.destroyed$)).subscribe(modelOptionState => {
      this.formattedModelOptions = modelOptionState.formattedOptions;
      this.filteredModelOPtions = modelOptionState.filteredModelOptions;

      this.selectedModelOptions = modelOptionState.selectedModelOptions;
      this.selectedModelOptionsValue = modelOptionState.selectedModelOptionsValues;

      this.calculateModelOptionState(this.selectedModelOptions);
    });
  }

  selectOption(modelOption: AdvancedSearchOption) {
    const index = this.selectedModelOptionsValue.findIndex(modelName => modelName === modelOption.vehicleModel);
    index === -1 ? this.addModelOption(modelOption) : this.removeModelOption(modelOption, index);
  }

  private addModelOption(modelOption: AdvancedSearchOption) {
    this.selectedModelOptions.push(modelOption);
    this.selectedModelOptionsValue.push(modelOption.vehicleModel);

    this.updateModelState();
  }
  private removeModelOption(modelOption: AdvancedSearchOption, index: number) {
    this.selectedModelOptions.splice(index, 1);
    this.selectedModelOptionsValue = this.selectedModelOptions.map(modelOption => modelOption.vehicleModel);

    this.updateModelState();
  }

  private updateModelState() {
    const state = this.advancedSearchService._modelOptions.getValue();
    const selectedModelOptions = this.selectedModelOptions;
    const selectedModelOptionsValues = this.selectedModelOptionsValue;
    // this.calculateModelOptionState(selectedModelOptions);

    this.advancedSearchService._modelOptions.next({
      ...state,
      selectedModelOptions,
      selectedModelOptionsValues
    });

    this.advancedSearchService.updateFilterOptions(VehicleInfo.VEHICLE_MODEL);
  }

  checked(modelOption: string) {
    return this.selectedModelOptionsValue.includes(modelOption);
  }

  onInput(e) {
    this.searchModel = e.target.value.replace(/[^ -~]+/g, '').toLowerCase();

    if (this.searchModel) {
      this.modelOptions$.pipe(takeUntil(this.destroyed$)).subscribe(modelOptionState => {
        this.filteredModelOPtions = modelOptionState.filteredModelOptions.filter(
          option =>
            option.vehicleMake.toLowerCase().includes(this.searchModel) ||
            option.vehicleModel.toLowerCase().includes(this.searchModel)
        );

        this.formattedModelOptions = this.advancedSearchService.makeModelFormatting(this.filteredModelOPtions);
      });
    } else {
      this.modelOptions$.pipe(takeUntil(this.destroyed$)).subscribe(modelOptionState => {
        this.filteredModelOPtions = modelOptionState.filteredModelOptions;
        this.formattedModelOptions = modelOptionState.formattedOptions;
      });
    }
  }

  close() {
    this.closePop.emit();
  }

  calculateModelOptionState(selectedModelOptions: AdvancedSearchOption[]) {
    this.selectedModelCount = selectedModelOptions.reduce((counts, model) => {
      if (typeof counts[model.vehicleMake] === 'undefined') {
        counts[model.vehicleMake] = 0;
      }
      counts[model.vehicleMake] += 1;
      return counts;
    }, {});
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
